import { lazy } from 'react';

export const CompatibilityLazy = lazy(() => import('./compatibility.land'));
